import { create } from 'zustand';

interface AuxDisciplinesState {
  openModal: string | undefined;
  playlistResultNumber: number;
  setOpenModal: (modal: string | undefined) => void;
  setPlaylistResultNumber: (qtd: number) => void;
}

export const useDisciplinesAuxStore = create<AuxDisciplinesState>((set) => ({
    openModal: undefined,
    playlistResultNumber: 0,
    setOpenModal: (modal: string | undefined) => set({ openModal: modal }),
    setPlaylistResultNumber: (qtd: number) => set({ playlistResultNumber: qtd })
  }),
);